export const PERMISSIONS = {

    // Tributos
    INMUEBLE_VIEW: 'inmueble_view',
    INMUEBLE_EDIT: 'inmueble_edit',
    COMERCIO_EDIT: 'comercio_edit',
    VEHICULO_EDIT: 'vehiculo_edit',
    CEMENTERIO_EDIT: 'cementerio_edit',
    FONDEADERO_EDIT: 'fondeadero_edit',
    CUENTA_ESPECIAL_EDIT: 'cuenta-especial_edit',
    CUENTA_EDIT: 'cuenta_edit',

    // Facturación
    RECIBO_ESPECIAL_EDIT: 'recibo-especial_edit',

    // Emisión
    PROCEDIMIENTO_EDIT: 'procedimiento_edit',

    // Financiación
    PLAN_PAGO_DEFINICION_EDIT: 'plan-pago-definicion_edit',
    PAGO_CONTADO_DEFINICION_EDIT: 'pago-contado-definicion_edit',

    // Escribanos
    CERTIFICADO_ESCRIBANO_EDIT: 'certificado-escribano_edit',

    // Legales
    CERTIFICADO_APREMIO_VIEW: 'certificado-apremio_view',
    CERTIFICADO_APREMIO_EDIT: 'certificado-apremio_edit',
    CERTIFICADO_APREMIO_CANCEL: 'certificado-apremio_cancel',
    APREMIO_VIEW: 'apremio_view',
    APREMIO_EDIT: 'apremio_edit',

    // Entidades
    TASA_EDIT: 'tasa_edit',
    CONTROLADOR_EDIT: 'controlador_edit',
    TIPO_MULTA_EDIT: 'tipo-multa_edit',
    LISTAS_INGRESOS_PUBLICOS_EDIT: 'listas_ingresos_publicos_edit',
    TIPO_MOVIMIENTO_EDIT: 'tipo-movimiento_edit',
    TABLA_DEFINICION_EDIT: 'tabla-definicion_edit',

    // Configuración
    PROCESO_VIEW: 'proceso_view',
    PROCESO_EDIT: 'proceso_edit',
    VARIABLE_EDIT: 'variable_edit',

    // Particulares
    DEBITOS_AUTOMATICOS_EDIT: 'debitos-automaticos_edit',
    DEBITOS_AUTOMATICOS_VIEW: 'debitos-automaticos_view',
    PERSONAS_VINCULADAS_EDIT: 'personas-vinculadas_edit',
    EXIMICIONES_EDIT: 'eximiciones_edit',
    CONDICION_ESPECIAL_EDIT: 'condicion-especial_edit',
    CUENTA_CORRIENTE_VIEW: 'cuenta-corriente_view',
    CUENTA_CORRIENTE_EDIT: 'cuenta-corriente_edit',
    CUENTA_PAGO_VIEW: 'cuenta-pago_view',
    CUENTA_PAGO_EDIT: 'cuenta-pago_edit',
    PLAN_PAGO_REACTIVACION_EDIT: 'plan-pago-reactivacion_edit',
    PLAN_PAGO_ANULACION_EDIT: 'plan-pago-anulacion_edit',
    EMISION_EDIT: 'emision_edit',
    DEBITO_CREDITO_EDIT: 'debito-credito_edit',
    DEBITO_EDIT: 'debito_edit',
    CREDITO_EDIT: 'credito_edit',
    CONDONACION_EDIT: 'condonacion_edit',
    VEP_EDIT: 'vep_edit',
    VEP_PLANES_EDIT: 'vep-planes_edit',
    LADO_TERRENO_EDIT: 'lado-terreno_edit',
    SUPERFICIE_EDIT: 'superficie_edit',
    LIQUIDACION_VIEW: 'liquidacion_view',
    CERTIFICADOS_EDIT: 'certificados_edit',
    DECLARACION_JURADA_VIEW: 'declaracion-jurada_view',
    DECLARACION_JURADA_EDIT: 'declaracion-jurada_edit',
    ELEMENTO_EDIT: 'elemento_edit',
    RUBROS_EDIT: 'rubros_edit',
    ESPACIO_ARRENDADO_EDIT: 'espacio-arrendado_edit',
    INHUMADO_EDIT: 'inhumado_edit',
};
